import React from 'react';
import { InputNumberProps } from 'antd/lib/input-number';

import { InputNumber as StyledInputNumber, WrapperInputNumber, Styledlabel } from './styled';

export const InputNumber = React.forwardRef<HTMLInputElement, CustomInputNumberProps>(
  ({ label, ...otherProps }, ref) => {
    return (
      <WrapperInputNumber>
        {label && <Styledlabel htmlFor='input-number'>{label}</Styledlabel>}
        <StyledInputNumber {...otherProps} ref={ref} id='input-number' />
      </WrapperInputNumber>
    );
  },
);

interface CustomInputNumberProps extends InputNumberProps {
  label?: string;
}
